// Hebrew validation and error text for the Entra change-password dialog.

// A user who signed in through Google (or another social provider) has no Entra
// password to change. The ID token's `idp` claim names the provider that
// authenticated the user; for the tenant's own email + password accounts it is
// absent or the tenant itself.
export const hasEntraPassword = (idTokenClaims) => {
  const idp = idTokenClaims?.idp;
  if (typeof idp !== 'string' || !idp) return true;
  return Boolean(idTokenClaims.tid) && idp.includes(idTokenClaims.tid);
};

// Mirrors Entra's own rule (8+ characters, 3 of 4 character kinds) so most mistakes
// are caught before the round trip. Microsoft still has the final say.
export const passwordRuleError = (password) => {
  if (password.length < 8) return 'הסיסמה צריכה להכיל לפחות 8 תווים';
  const kinds = [/[a-z]/, /[A-Z]/, /\d/, /[^a-zA-Z\d]/].filter(kind => kind.test(password)).length;
  if (kinds < 3) return 'הסיסמה צריכה לשלב לפחות שלושה מתוך: אותיות קטנות, אותיות גדולות, ספרות וסימנים';
  return '';
};

// Graph returns English messages without stable codes for these cases, so the
// mapping keys off their wording and falls back to a generic message.
export const graphErrorMessage = (error) => {
  const message = `${error?.code || ''} ${error?.message || ''}`;
  if (/complexity|policy|requirement|weak|length|banned|history|previous/i.test(message)) {
    return 'הסיסמה החדשה אינה עומדת בדרישות האבטחה. נסו סיסמה אחרת.';
  }
  if (/current|old|invalid|incorrect|credential/i.test(message)) {
    return 'הסיסמה הנוכחית שגויה';
  }
  return 'לא הצלחנו לעדכן את הסיסמה. נסו שוב מאוחר יותר.';
};

export const clientErrorMessage = (error) => {
  const code = error?.errorCode || '';
  if (code === 'user_cancelled' || code === 'popup_window_error' || code === 'empty_window_error') {
    return 'חלון האישור של Microsoft נסגר או נחסם. יש לאפשר חלונות קופצים ולנסות שוב.';
  }
  return 'לא הצלחנו להתחבר ל-Microsoft. נסו שוב.';
};
